import React, { useMemo } from "react";
import { getAvailableAccountTypes } from "@common/constants/domains/accounting/accountTypeHelpers";
import { AccountClass } from "@common/constants/domains/accounting/accounts";
import { BaseCellProps } from "./index";
import { DropdownCell } from "./DropdownCell";
import { buildAccountTypeCellOptions } from "./accountTypeCellOptions";

interface AccountTypeCellProps extends BaseCellProps<string> {
    availableClassifications?: AccountClass[];
}

export const AccountTypeCell: React.FC<AccountTypeCellProps> = ({
    row,
    availableClassifications,
    ...props
}) => {
    const rowAccountClass = row.accountClass as AccountClass | null;

    const allAccountTypes = useMemo(() => {
        const classesToFilter = rowAccountClass
            ? [rowAccountClass]
            : availableClassifications;

        return getAvailableAccountTypes(classesToFilter);
    }, [rowAccountClass, availableClassifications]);

    const options = useMemo(
        () =>
            buildAccountTypeCellOptions({
                accountTypes: allAccountTypes,
            }),
        [allAccountTypes],
    );

    return <DropdownCell {...props} row={row} options={options} />;
};
